import * as Types from '@haaretz/s-fragments/Types';


/**
 * -----------------------------------------------------------------------------
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 * -----------------------------------------------------------------------------
 * This file was automatically generated by GraphQL Codegen.
 * Any manual changes will be overwritten.
 * -----------------------------------------------------------------------------
 */

export type MarketingBulletFragment = (
  { text?: string | null, title: string }
  & { __typename: 'MarketingBullet' }
);


export type MarketingBulletFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const MarketingBulletFragmentGql = `
    fragment MarketingBulletFragment on MarketingBullet {
  __typename
  text
  title
}
    `;